import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ChromePicker } from 'react-color';
import {SortableHandle} from 'react-sortable-hoc';

import classes from './LayerItem.module.css';
import Spinner from '../../components/Spinner/Spinner';
import OpacitySlider from '../OpacitySlider/OpacitySlider';
import SwitchButton from '../../components/UI/Buttons/SwitchButton';
import * as actions from '../../store/actions/index';

// Can have sortable, showSymbol, showStyling, showTable, showZoom, showVisibility, showDelete, showOpacity
// Requires index.
// Requires mapLayer object. Example:
// mapLayer = {
//     id:1,
//     data:{}, // Geojson or connection parameters for wms
//     name: "",
//     group_id: 1,
//     group: "",
//     published: true,
//     downloads: true,
//     bounds: [],
//     geoserver_url: "",
//     connection: "wms", // How to get the data: wms, wfs, wcs, internal
//     visible: false,
//     viewparams: "",
//     filter: "",
//     type: "polygon", // Polygon, line, point, raster
//     style: {
//         fillColor:"rgba(0,0,0,0)",
//         color:"rgba(0,0,0,1)",
//         fillOpacity:1,
//         opacity:1,
//         weight:2
//     }
// }


// TODO: The application hangs when geoserver is not working
class LayerItem extends Component {

    state = {
        displayFillColorPickerIndex: -1,
        displayBorderColorPickerIndex: -1,
        displayStylingIndex: -1,
        // displayLegendIndex: -1,
        // displayOpacityIndex: -1
        // displayMapTable: false
    }

    openItem = (item, layerIndex) => {
        if (layerIndex === this.state[item]) {
            this.setState({[item]: -1});
        } else {
            this.setState({[item]: layerIndex});
        }
    }

    // Open table --------------------------------------
    openTable = (layerIndex) => {
        this.props.onUpdateMapTable(layerIndex, this.props.collection);
        // this.setState({displayMapTable: true});
    }

    rgbToHex = (rgbColor) => {
        const rgbArr = rgbColor.split("(")[1].split(",");
        return "#" + ((1 << 24) + (parseInt(rgbArr[0],10) << 16) + (parseInt(rgbArr[1],10) << 8) + parseInt(rgbArr[2],10)).toString(16).slice(1);
    }

    handleCloseColorPicker = () => {
        this.setState({ displayFillColorPickerIndex: -1 })
        this.setState({ displayBorderColorPickerIndex: -1 })
    };
    

    // Zoom to layer --------------------------------------
    zoomToLayer = (layerIndex) => {
        this.props.onUpdateMapKey();
        this.props.onUpdateMapBounds(this.props.mapLayer.bounds);
    }
    
    render(){
        // If layer is sortable, show draghandle
        let draghandle = null;
        if (this.props.sortable){
            const DragHandle = SortableHandle(() => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                                    <path d="M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"></path>
                                                </svg>);
            draghandle = <div className={classes.DragHandle}>
                            <DragHandle />
                        </div>
        }
        
        // if layer has showSymbol, show symbol
        let layerItemSymbol = null;
        let legendIcon = null;
        if (this.props.showSymbol){
            legendIcon = <div className={this.props.mapLayers[this.props.index].displayLegend ? [classes.LayerItemTool, classes.Active].join(" ") : classes.LayerItemTool} onClick={() => this.props.onToggleLegend(this.props.index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"></path></svg>
                        </div>

            if (this.props.mapLayer.style.field){

                layerItemSymbol = this.props.mapLayers[this.props.index].style.classes.map((style,index) => {
                    return <div key={`layerSymbol_${index}`} className={classes.FlexRowCenter}>
                                <div className={classes.LayerItemSymbolDiv}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 95"
                                        style={{
                                            "fill":style.style.fillColor,
                                            "fillOpacity":style.style.fillOpacity * this.props.mapLayers[this.props.index].layerOpacity,
                                            "stroke":style.style.color,
                                            "strokeOpacity":style.style.opacity,
                                            "strokeWidth":parseInt(style.style.weight,10) + 3
                                        }}
                                    >
                                        {/* <path d="M18.164 90.45L0 34.55 47.553.001 95.106 34.55l-18.164 55.9z" /> {/* Pentagon */} 
                                        <rect x="0" y="0" width="100%" height="100%"/> {/* Rectangle */}
                                    </svg>
                                </div>
                                <span>{style.label}</span>
                            </div>
                })

                // layerItemSymbol = <svg className={classes.LayerItemSymbol} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 95"
                //                         style={{
                //                             "fill":this.props.mapLayer.style.fillColor,
                //                             "fillOpacity":this.props.mapLayer.style.fillOpacity,
                //                             "stroke":this.props.mapLayer.style.color,
                //                             "strokeWidth":parseInt(this.props.mapLayer.style.weight,10) + 3
                //                         }}
                //                     >
                //                         <path d="M18.164 90.45L0 34.55 47.553.001 95.106 34.55l-18.164 55.9z" />
                //                     </svg>
    
                // if (this.props.mapLayer.type === "line"){
                //     layerItemSymbol = <svg className={classes.LayerItemSymbol} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.411 26.411"
                //                         style={{
                //                             "fill":"none",
                //                             "strokeLinecap":"round",
                //                             "stroke":this.props.mapLayer.style.color,
                //                             "strokeWidth":parseInt(this.props.mapLayer.style.weight,10)
                //                         }}
                //                     >
                //                         <path d="M.706 25.706l22-25"/>
                //                     </svg>
    
                // } else if (this.props.mapLayer.type === "point"){
                //     layerItemSymbol = <svg className={classes.LayerItemSymbol} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
                //                         <circle cx="14" cy="14" r="14" stroke="none" fill={this.props.mapLayer.style.fillColor} />
                //                         <circle cx="14" cy="14" r="13.5" fill="none" stroke={this.props.mapLayer.style.color} strokeWidth={parseInt(this.props.mapLayer.style.weight,10)} />
                //                     </svg>
                // }
            } else {
                let envString = "";
                if (this.props.mapLayer.style.env){
                    envString = "&env=color:" + this.props.mapLayer.style.env;
                } 

                layerItemSymbol = <div className={classes.LayerItemSymbolImage}>
                                    <img src={this.props.geoserverUrl + "wms?REQUEST=GetLegendGraphic&VERSION=2.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&legend_options=fontName:Noto%20Sans;fontColor:525252;fontSize:13;fontAntiAliasing:true;dx:5&LAYER=" + this.props.mapLayer.data.layer + envString} alt={this.props.mapLayer.name + " name"} />
                                </div>
            }
        } 

        // if layer has showStyling, show styling icon and styling div
        let stylingIcon = null;
        let stylingDiv = null;
        if (this.props.showStyling){
            const popover = {
                position: 'absolute',
                zIndex: '2',
            }
            const cover = {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
            }

            stylingIcon = <div className={this.state.displayStylingIndex === this.props.index ? [classes.LayerItemTool, classes.Active].join(" ") : classes.LayerItemTool} onClick={() => this.openItem("displayStylingIndex", this.props.index)}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                    <path d="M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"></path>
                                </svg>
                            </div>

            stylingDiv =  <div className={this.state.displayStylingIndex === this.props.index ? [classes.LayerStyling, classes.Active].join(" ") : classes.LayerStyling}>
                                <div className={classes.FlexTableRow}>
                                    <div className={classes.FlexCell1}>Fill color:</div>
                                    <input className={classes.FlexCell2} value={this.rgbToHex(this.props.mapLayer.style.fillColor)} readOnly onClick={() => this.openItem("displayFillColorPickerIndex", this.props.index)}/>
                                    { this.state.displayFillColorPickerIndex === this.props.index
                                        ? <div style={ popover }>
                                                <div style={ cover } onClick={ this.handleCloseColorPicker }></div>
                                                <ChromePicker 
                                                    key={"fillPicker_" + this.props.index}
                                                    color={ this.props.mapLayer.style.fillColor }
                                                    onChangeComplete={ this.props.handleFillColor }
                                                />
                                            </div> 
                                        : null 
                                    }
                                </div>
                                <div className={classes.FlexTableRow}>
                                    <div className={classes.FlexCell1}>Border color:</div>
                                    <input className={classes.FlexCell2} value={this.rgbToHex(this.props.mapLayer.style.color)} readOnly onClick={() => this.openItem("displayBorderColorPickerIndex", this.props.index)}/>
                                    { this.state.displayBorderColorPickerIndex === this.props.index
                                        ? <div style={ popover }>
                                                <div style={ cover } onClick={ this.handleCloseColorPicker }></div>
                                                <ChromePicker 
                                                    key={"fillPicker_" + this.props.index}
                                                    color={ this.props.mapLayer.style.color }
                                                    onChangeComplete={ this.props.handleBorderColor }
                                                />
                                            </div> 
                                        : null 
                                    }
                                </div>
                                <div className={classes.FlexTableRow}>
                                    <div className={classes.FlexCell1}>Border width:</div>
                                <input className={classes.FlexCell2} type="number" min="1" max="10" defaultValue={this.props.mapLayer.style.weight} onChange={this.props.handleBorderWidth} />
                            </div>
                        </div>
        }

        // if layer has showTable, show table icon
        let tableIcon = null;
        if (this.props.showTable){
            tableIcon = <div className={this.props.activeTable ? [classes.LayerItemTool, classes.Active].join(" ") : classes.LayerItemTool} onClick={() => this.openTable(this.props.index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.952 65.863">
                                <path data-name="Path 57" d="M69.624 2.698a4.373 4.373 0 00-4.2-2.7q-7.179.01-14.358 0H4.528a4.376 4.376 0 00-4.2 2.7A8.671 8.671 0 000 4.212v57.771a3.962 3.962 0 001.506 2.868 4.684 4.684 0 003.112 1.011q30.359-.008 60.717 0c.186 0 .373.008.558-.008a4.418 4.418 0 003.709-2.42c.193-.352.164-.763.348-1.112V4.212a8.669 8.669 0 00-.326-1.514zM48.572 13.247q8.262.021 16.523 0c.43 0 .509.118.507.522q-.024 6.057 0 12.113c0 .412-.089.53-.515.527-2.754-.021-5.508-.01-8.262-.01-2.717 0-5.434-.015-8.15.014-.529.006-.63-.158-.628-.651q.029-6 0-12c-.001-.435.119-.516.525-.515zm-21.891 0c2.772.012 5.545.007 8.317.007 2.754 0 5.508.009 8.262-.009.4 0 .485.109.484.493q-.022 6.084 0 12.169c0 .391-.11.5-.5.5q-8.261-.018-16.523 0c-.373 0-.512-.079-.51-.486q.022-6.112 0-12.225c-.004-.391.127-.448.469-.446zm-21.866 0c2.775.014 5.55.008 8.325.008 2.756 0 5.513.008 8.269-.009.384 0 .5.086.494.485q-.023 6.09 0 12.18c0 .4-.12.493-.5.493q-8.3-.017-16.594 0c-.378 0-.455-.116-.454-.471q.018-6.118 0-12.236c-.007-.377.108-.45.459-.448zm-.465 17.94c0-.394.1-.49.493-.489q8.266.02 16.533 0c.416 0 .529.1.527.523q-.025 6.228 0 12.455c0 .444-.12.564-.564.56-2.755-.02-5.511-.01-8.266-.01-2.718 0-5.436-.008-8.154.008-.412 0-.573-.067-.571-.536q.029-6.253.001-12.509zM21.9 60.823c0 .434-.1.562-.55.561q-8.24-.023-16.481 0c-.411 0-.527-.091-.525-.52q.028-6.061 0-12.123c0-.414.093-.521.514-.518 2.775.021 5.55.011 8.324.011 2.719 0 5.438.008 8.157-.008.41 0 .565.065.562.532q-.029 6.031-.001 12.065zm4.306-29.633c0-.4.121-.49.5-.489q8.267.017 16.534 0c.4 0 .5.116.495.5q-.018 6.256 0 12.512c0 .419-.115.529-.532.526-2.755-.019-5.511-.01-8.267-.01-2.718 0-5.437-.007-8.155.007-.4 0-.585-.054-.582-.534q.038-6.256.01-12.512zm17.539 29.615c0 .476-.137.577-.591.575q-8.178-.024-16.357 0c-.454 0-.592-.108-.59-.577q.029-6 0-12c0-.448.082-.589.564-.584 2.754.027 5.508.013 8.262.013 2.717 0 5.434.007 8.15-.008.4 0 .564.058.561.527q-.031 6.029.001 12.054zM48.7 30.697c2.718.024 5.436.011 8.155.011 2.737 0 5.474.012 8.21-.012.454 0 .542.134.541.558q-.023 6.2 0 12.4c0 .46-.113.585-.579.584q-8.183-.025-16.365 0c-.5 0-.613-.141-.611-.626q.03-6.144 0-12.288c-.008-.527.149-.631.649-.627zm16.9 30.167c0 .431-.117.521-.525.518-2.772-.018-5.545-.009-8.317-.009-2.717 0-5.433-.008-8.15.008-.416 0-.568-.075-.565-.541q.032-6.028 0-12.057c0-.488.148-.562.59-.561q8.206.023 16.411 0c.406 0 .561.061.558.527q-.029 6.056-.002 12.115z"/>
                            </svg>
                        </div>
        }

        // if layer has showZoom, show zoom icon
        let zoomIcon = null;
        if (this.props.showZoom){
            zoomIcon = <div className={classes.LayerItemTool} onClick={() => this.zoomToLayer(this.props.index)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.987 49.8">
                                <path d="M37.3 30.6c4 3.9 7.8 7.8 11.6 11.6a4.466 4.466 0 01.7 4.8 4.245 4.245 0 01-4.1 2.8 4.777 4.777 0 01-3.8-1.6c-3.4-3.5-6.8-6.9-10.3-10.3-.7-.7-.6-.9.1-1.4a19.228 19.228 0 005.8-5.9z"/>
                                <path d="M18.8 9.4c-.1.5-.3 1.7-1.6 1.8a7.656 7.656 0 00-6.2 6.6c-.1.8-.3 1-1.1 1-2.3 0-2.4-.1-1.9-2.3a11.054 11.054 0 019.7-8.7c1.6-.1 1.1 1 1.1 1.6z"/>
                                <path d="M34.6 29a18.524 18.524 0 003-10.2 18.8 18.8 0 00-37.6 0 19.758 19.758 0 00.8 5.5c.1.3.2.6.3 1 .1.2.1.4.2.6A19.166 19.166 0 0013.8 37a19.989 19.989 0 004.9.7 15.535 15.535 0 003.7-.4 19.219 19.219 0 0011.5-7.4l.1-.1a5.548 5.548 0 00.6-.8zm-15.9 3.9a14.1003546 14.1003546 0 11.2-28.2 14.1003546 14.1003546 0 01-.2 28.2z"/>
                            </svg>
                        </div>
        }

        // if layer has showVisibility, show visibility icon
        let visibilityIcon = null;
        if (this.props.showVisibility){
            if (this.props[this.props.collection + "Loading"].length > 0 && this.props[this.props.collection + "Loading"].includes(this.props.index)) {
                visibilityIcon = <div className={classes.LayerItemTool}>
                                    <Spinner />
                                </div>
            } else {
                visibilityIcon = <div className={this.props[this.props.collection][this.props.index].visible ? [classes.LayerItemTool, classes.Active].join(' ') : classes.LayerItemTool} onClick={() => this.props.onUpdateLayerVisibility(this.props.index, this.props.collection)}>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"></path></svg> */}
                                    <SwitchButton active={this.props[this.props.collection][this.props.index].visible}/>
                                </div>
            }            
        }

        // if layer has showDelete, show delete icon
        let deleteIcon = null;
        if (this.props.showDelete){
            deleteIcon = <div className={classes.LayerItemTool} onClick={() => this.props.onRemoveLayerItem(this.props.index, this.props.collection)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
                        </div>
        }

        // if layer has showOpacity, show opacity icon
        let opacityIcon = null;
        if (this.props.showOpacity){
            opacityIcon = <div className={this.props.displayOpacityIndex === this.props.index ? [classes.LayerItemTool, classes.Active].join(' ') : classes.LayerItemTool}>
                            <svg onClick={this.props.opacityClickHandle} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 32"><path d="M29.333 7.92c-0.761-1.345-1.646-2.503-2.667-3.526l0 0v23.211c1.040-1.040 1.939-2.224 2.667-3.525v-16.16zM21.333 0.88c-0.752-0.308-1.646-0.577-2.569-0.762l-0.098-0.016v31.797c0.92-0.179 1.813-0.443 2.667-0.779v-30.24zM13.333 32c-7.547-1.181-13.333-7.893-13.333-16s5.787-14.819 13.333-16v32z"></path></svg>
                            <div className={this.props.displayOpacityIndex === this.props.index ? [classes.LayerOpacity, classes.Active].join(" ") : classes.LayerOpacity}>
                                <span>Διαφάνεια</span>
                                <OpacitySlider 
                                    percentage={this.props[this.props.collection][this.props.index].layerOpacity * 100}
                                    changed={(percentage) => this.props.onChangeLayerOpacity(this.props.index, percentage, this.props.collection)}
                                />
                            </div>
                        </div>
        }

        return (
            <div className={classes.LayerItemWrapper} key={"layerItem_" + this.props.index}>
                <div className={classes.FlexRow}>
                    
                    {draghandle}
                    
                    <div className={this.props.index === 4 ? [classes.LayerItem, classes.LastLayerItem].join(' ') : classes.LayerItem}>
                        <div className={classes.FlexRowCenter}>
                            <div className={classes.LayerItemTitle}>{this.props.mapLayer.label}</div>  
                            <div className={classes.LayerItemTools}>
                                {legendIcon}
                                {opacityIcon}
                                {stylingIcon}
                                {tableIcon}
                                {zoomIcon}
                                {visibilityIcon}
                                {deleteIcon}
                            </div>
                        </div>
                        <div className={this.props.mapLayers[this.props.index].displayLegend ? [classes.LayerItemSymbolWrapper, classes.Active].join(' ') : classes.LayerItemSymbolWrapper}>
                            {layerItemSymbol}
                        </div>
                    </div>
                </div>

                {stylingDiv}
               
        </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        geoserverUrl: state.system.geoserverUrl,
        mapLayers: state.layerItems.mapLayers,
        mapLayersLoading: state.layerItems.mapLayersLoading,
        queryMapLayers: state.layerItems.queryMapLayers,
        queryMapLayersLoading: state.layerItems.queryMapLayersLoading
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onUpdateMapBounds: (mapBounds) => dispatch(actions.updateMapBounds(mapBounds)),
        onUpdateLayerVisibility: (index, collection) => dispatch(actions.updateLayerVisibility(index, collection)),
        onChangeLayerOpacity: (index, percentage, collection) => dispatch(actions.changeLayerOpacity(index, percentage, collection)),
        // onUpdateLayerFillColor: (index,fillColor, collection) => dispatch(actions.updateLayerFillColor(index,fillColor, collection)),
        // onUpdateLayerBorderColor: (index,borderColor, collection) => dispatch(actions.updateLayerBorderColor(index,borderColor, collection)),
        // onUpdateLayerBorderWidth: (event,index, collection) => dispatch(actions.updateLayerBorderWidth(event,index, collection)),
        // onUpdateMapLayersOrder: (event, collection) => dispatch(actions.updateMapLayersOrder(event, collection)),
        onUpdateMapTable: (index, collection) => dispatch(actions.updateMapTable(index, collection)),
        // onRemoveLayerItem: (index, collection) => dispatch(actions.removeLayerItem(index, collection)),
        onUpdateMapKey: () => dispatch(actions.updateMapKey()),
        onToggleLegend: (layerIndex) => dispatch(actions.toggleLegend(layerIndex))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LayerItem);